import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'layoutComponents/Loading';
class Delay extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            waiting: true
        };

    }

    componentDidMount()
    {
        this.timer = setTimeout(() => {
            this.setState({waiting: false});
        }, this.props.wait);
    }

    componentWillUnmount()
    {
        clearTimeout(this.timer);
    }

    render()
    {
        if (!this.state.waiting) {
            return this.props.children;
        }

        return <div><Loading isLoading/></div>;
    }

}

Delay.propTypes = {
    wait: PropTypes.number,
    children: PropTypes.object
};

export default Delay;


// WEBPACK FOOTER //
// ./src/components/layout/Delay.js